// Service Tiles Imports
import sImgS1 from '../images/service-single/img-1.jpg'
import sImgS2 from '../images/service-single/img-2.jpg'
import sImgS3 from '../images/service-single/img-3.jpg'
import sImgS4 from '../images/service-single/img-4.jpg'

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'

/*

*** Table of Contents: ***
1. Hero
2. Navbar
3. Tiles
4. Features
5. Footer
6. About Us Page
7. Contact Form
8. Studies List
9. 4DWW Company Directory
10. Slider Data

*/

// 1. Hero
export const homepgHeroData = {
    heroSlideTitleSub: "Let’s make Colorado a leader in the future of work.",
    heroTitle: "The Movement for a 32 Hour Work Week in Colorado Starts Now",
    heroSlideText: "A shorter work week means happier employees, stronger businesses, and a better quality of life for all.",
    heroBtnText: "Join The Movement"
}

// 2. Navbar
export const homepgNavbarData = {
    tabs: [
        {name: "Home", link: "/"},
        {name: "About Us", link: "/about"},
        {name: "Studies", link: "/studies"},
        {name: "Contact", link: "/contact"},
        {name: "Join the Movement", link: "/jtm"},
        {name: "4DWW Directory", link: "/directory"},
    ]
}

// 3. Tiles
export const hpServiceSection = {
    subTitle: "Mission And Vision", 
    title: 'How we can build a better state (and country) together!',
    services: [
        {
            Id: '1',
            sImgS:sImgS1,
            sTitle: 'Happier, Healthier Employees',
            // slug:'Economic-Establishment',
            description:'A shorter workweek leads to improved mental health, reduced burnout, and better work-life balance.',
            des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
            des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            icon: 'flaticon-team-work',
            ssImg1:sSingleimg1,
            ssImg2:sSingleimg2,
        },
        {
            Id: '2',
            sImgS:sImgS2,
            sTitle: 'Productivity That Speaks for Itself',
            // slug:'Jobs-and-Unemployment',
            description:'Studies show that businesses adopting a 4-day week see a boost in output, fewer sick days, and even revenue growth — see our Studies page for more.',
            des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
            des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            icon:'flaticon-job',
            ssImg1:sSingleimg1,
            ssImg2:sSingleimg2,
        },
        {
            Id: '3',
            sImgS:sImgS3,
            sTitle: 'Smarter Business',
            // slug:'Business-and-Industry',
            description:'Shorter workweeks can reduce operating costs, absenteeism, and employee turnover — helping companies save money without sacrificing quality.',
            des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
            des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            icon:'flaticon-credit',
            ssImg1:sSingleimg1,
            ssImg2:sSingleimg2,
        },
        {
            Id: '4',
            sImgS:sImgS4,
            sTitle: 'A Win for the Planet',
            // slug:'Roads-and-Transport-Service',
            description:'Fewer commuting days reduce carbon emissions, traffic, and stress — giving workers more time to contribute to their families, neighborhoods, and civic life.',
            des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
            des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
            icon:'flaticon-bus',
            ssImg1:sSingleimg1,
            ssImg2:sSingleimg2,
        },
    ]
}

// 4. Features
export const homepgFeaturesData = {
    features: [
        {
            featuresText: "Our Mission", 
            paragraphText: "Establish a 4 day work week for all workers across all industries - blue collar, white collar, and everything in between.",
            flaticon: "fi flaticon-conference-1",
            flaticonHidden: "fi flaticon-conference-1",
            to: "/about",
            id: 1
        },
        {
            featuresText: "Our Goals",
            paragraphText: "We aim to pass legislation in Colorado establishing a 4-day, 32-hour workweek by 2027–2028, ensuring no loss in pay or benefits.",
            flaticon: "fi flaticon-goal", 
            flaticonHidden: "fi flaticon-goal", 
            to: "/about",
            id: 2
        },
        {
            featuresText: "Make Donation", 
            paragraphText: "Make a difference by taking action with your donation.",
            flaticon: "fi flaticon-charity", 
            flaticonHidden: "fi flaticon-charity", 
            to: "/donate",
            id: 3
        },
        {
            featuresText: "Join/Volunteer", 
            paragraphText: "Join our team of volunteers and help make a positive impact in our community today.",
            flaticon: "fi flaticon-community",
            flaticonHidden: "fi flaticon-community",
            to: "/jtm",
            id: 4
        },
    ]
}

// 5. Footer
export const homepgFooterData = {
    info: "tristan.collins@workfour.org",
    socials: [
        {flaticon: "fi flaticon-linkedin", link: "https://www.linkedin.com/company/workfour/", id: 1},
        {flaticon: "fi flaticon-instagram-1", link: "https://www.instagram.com/letsworkfour/", id: 2}
    ],
    quickLinkTitle: "Quick Links",
    quickLinks: [
        {name: "Home", link: "/"},
        {name: "About Us", link: "/about"},
        {name: "Studies", link: "/studies"},
        {name: "Contact", link: "/contact"},
        {name: "Join the Movement", link: "/jtm"},
    ]
}

// 6. About Us Page
export const aboutUsMain = {
    // header: 
    bioSpan: "About WorkFour Colorado",
    paragraphs: [
        "We are the Colorado chapter of the growing national movement for a 4-day work week with no reduction in pay. Our mission is to make Colorado a leader in fair, forward-thinking labor policy by pushing for a 32-hour work week standard statewide by 2027–2028.",
        "Across white-collar, blue-collar, and frontline jobs, we believe everyone deserves more time to rest, recharge, and live. Research shows that a 4-day week increases productivity, improves mental and physical health, reduces burnout, and helps businesses retain great employees.",
        "Even in jobs where someone needs to be on-site — like cashiers, drivers, factory workers, and customer service — a shorter work week creates more jobs, stronger local economies, and happier customers."

    ],
    quoteParagraph: "This is not just a worker issue — it’s a quality of life issue. It’s about building a better future for workers and employers."
}

// 7. Contact Form
export const contactFormData = {
    options: [
        {text: "Employee Involvement", id: 1},
        {text: "Employer Involvement", id: 2},
        {text: "Organization Goals", id: 3},
        {text: "Bringing the 4DWW to my Workplace", id: 4},
        {text: "Unionizing Efforts", id: 4},
        {text: "Other", id: 5}
    ]
}

// 8. Studies List
export const studiesList = {
    studiesData: [
        {
          title: 'Golden, CO Police Department',
          source: 'Guiding Golden',
          highlights: [
            '• Decreased overtime spending',
            '• Improved emergency response times',
            '• Boosted Employee Retention',
          ],
          link: 'https://www.guidinggolden.com/the-best-for-golden'
        },
        {
          title: 'UK 4-Day Week Pilot (2022)',
          source: '4 Day Week Global, Autonomy, and Cambridge University',
          highlights: [
            '• 61 companies partticipated and 92% continued with 4-day week after the pilot',
            '• 39% of employees were less stressed',
            '• 71% reported reduced burnout'
          ],
          link: 'https://www.4dayweek.com/uk-pilot-results'
        },
        {
          title: 'Microsoft Japan Trial',
          source: 'The Guardian',
          highlights: [
            '• Productivity increased by 40%, measured by sales per employee',
            '• Reduced electricity usage by 23% and paper printing by 59%',
            '• Over 90% of employees reported being positively impacted' 
          ],
          link: 'https://www.theguardian.com/technology/2019/nov/04/microsoft-japan-four-day-work-week-productivity'
        }
    ]
}

// 9. 4DWW Company Directory
export const companyDirectoryData = {
    businesses: [
        { name: "Gunbarrel Dental Center", industry: "Dental", city: "Boulder", website: "https://www.gunbarreldental.com/", type: "32 Hours" },
        { name: "Boulder Valley Dental Center", industry: "Dental", city: "Louisville", website: "https://www.bouldervalleydental.com/", type: "31 Hours" },
        { name: "Michelle N. Messina, DDS", industry: "Dental", city: "Louisville", website: "https://www.messinadds.com/", type: "32 Hours" },
        { name: "Cedar Circle Counseling", industry: "Counseling", city: "Cedaredge", website: "https://www.cedarcirclecounseling.com/", type: "32 Hours" },
        // { name: "Colorado Immigrant Rights Coalition", industry: "Non‑profit", city: "Denver", website: "https://coloradoimmigrant.org" },
        { name: "Center for People with Disabilities", industry: "Non‑profit", city: "Boulder", website: "https://www.cpwd.org/", type: "34 Hours" },
        { name: "Golden, CO Police Department", industry: "Emergency Services", city: "Golden", website: "https://crimewatch.net/us/co/jefferson/golden-pd", type: "32 Hours" },
        { name: "Clear Creek County Colorado", industry: "Government", city: "Multiple", website: "https://www.clearcreekcounty.us", type: "32 Hours" },
        { name: "Jefferson County Colorado", industry: "Government", city: "Multiple", website: "https://www.jeffco.us", type:"40 hours (4 10 hour days)" },
        { name: "Digible", industry: "Marketing", city: "Englewood", website: "https://digible.com", type: "32 Hours" },
        
    ],
    title: "Colorado Employers on a 4‑Day Work Week",
    blurb: "A living directory of Colorado organizations adopting or piloting 32–36 hour work weeks."
};

// 10. Slider Data
export const slides = [
  { heroTitle: 'The Movement For A 32 Hour Work Week In Colorado Starts Now',
    heroSlideTitleSub: 'Let’s make Colorado a leader in the future of work.',
    heroSlideText: 'Shorter weeks mean happier employees and stronger businesses.',
    heroBtnText: 'Sign the Petition', heroBtnHref: 'https://www.change.org/p/urge-the-colorado-legislature-to-launch-a-4-day-workweek-pilot?source_location=psf_petitions' },
  { heroTitle: '4-Day Weeks Increase Retention & Productivity',
    heroSlideTitleSub: 'Evidence-backed results',
    heroSlideText: 'See peer-reviewed research and Colorado case studies.',
    heroBtnText: 'Explore the Studies', heroBtnHref: '/studies' },
  { heroTitle: 'Better Balance. Better Business. Better Colorado.',
    heroSlideTitleSub: 'Quality of life up, burnout down',
    heroSlideText: 'Join partners across the state pushing for 32 hours.',
    heroBtnText: 'Get Involved', heroBtnHref: '/contact' },
];